import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import NavigationTop from "../../components/NavigationTop/NavigationTop";
import Pagination from "../../components/Pagination/Pagination";
import styles from "./TopContributors.module.css";

import { fetchTopContributors, resetContributors } from "../../store/slices/topContributorsSlice";

import countFiles from "../../assets/svg/countFiles.svg";
import iconimg from "../../assets/images/iconplaceholder.png";

const TopContributors = () => {
  const dispatch = useDispatch();

  const { contributors, status, totalPages, totalCount } = useSelector(
    (state) => state.topContributors
  );
  // totalCount приходит из API (total_items)
  const { isAuthenticated } = useSelector((state) => state.user);

  const [page, setPage] = useState(1);
  const pageSize = 12;

  useEffect(() => {
    dispatch(fetchTopContributors({ page, pageSize }));
  }, [dispatch, page]);

  useEffect(() => {
    return () => {
      dispatch(resetContributors());
    };
  }, [dispatch]);

  const paginationData = {
    count: totalCount,
    next: page < totalPages ? page + 1 : null,
    previous: page > 1 ? page - 1 : null,
  };


  return (
    <div>
      <Helmet>
        <title>Distortion Grids Database – Top Contributors</title>
        <meta
          name="description"
          content="Meet the top contributors who power the Distortion Grids Database. Ranked by uploaded and approved assets."
        />
        <meta property="og:title" content="Distortion Grids Database – Top Contributors" />
        <meta
          property="og:description"
          content="Meet the top contributors who power the Distortion Grids Database. Ranked by uploaded and approved assets."
        />
      </Helmet>
      <NavigationTop yourCustomClass="top-contrik"
        title="Top Contributors"
        text={<>We spotlight the incredible users who power the Distortion Grids Database! This page recognizes our top contributors, ranked by the number of their uploaded assets that have passed moderation.<br/>Your contributions are vital in building a fantastic resource for the community.</>}
      />
      <section className="height" style={{ paddingTop: "0" }}>
        {totalPages > 1 && (
          <Pagination pagination={paginationData} customPageSize={pageSize} currentPage={page} onPageChange={setPage} />
        )}

        <div className={styles.main}>
          {contributors.map((item, index) => (
            <Link
              to={`/profile/${item.id}`}
              key={index}
              className={styles.user}
            >
              <p className={styles.number}>{item.position}.</p>
              <div style={{ width: "60px", height: "60px", borderRadius: "5px", overflow: "hidden", flexShrink: 0 }}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                    transform: item.profile_picture ? "none" : "scale(1.3)",
                  }}
                  src={item.profile_picture || iconimg}
                  alt="icon"
                />
              </div>
              <div className={styles.info}>
                <p className={styles.name}>{item.username}</p>
                <div className={styles.countBlcok}>
                  <img src={countFiles} alt="icon" />
                  <p style={{ fontSize: "24px" }}>{item.total_products}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </section>
    </div>
  );
};

export default TopContributors;